import { render, staticRenderFns } from "./AiToolsSidebar.vue?vue&type=template&id=40f50aa8&scoped=true&"
import script from "./AiToolsSidebar.vue?vue&type=script&lang=js&"
export * from "./AiToolsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AiToolsSidebar.vue?vue&type=style&index=0&id=40f50aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f50aa8",
  null
  
)

export default component.exports